import { render, staticRenderFns } from "./BlockDocument.vue?vue&type=template&id=198bea3e&scoped=true&"
import script from "./BlockDocument.vue?vue&type=script&lang=js&"
export * from "./BlockDocument.vue?vue&type=script&lang=js&"
import style0 from "./BlockDocument.vue?vue&type=style&index=0&id=198bea3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198bea3e",
  null
  
)

export default component.exports